module.exports = "https://static.wmbcdn.com/uniweb/images/e0e0b489826d6d31b28f7aef82d0f94e.svg";